import { Input } from 'avo-ui'
import ModalForm from 'components/commons/modal-form'
import Select from 'components/commons/select'

export const FormAwardCategory = ({
    show,
    onHideForm,
    dataAwardCategory,
    options,
    isLoading,
    isDisabled,
    onChangeForm,
    onSubmit,
}) => {
    return (
        <ModalForm
            className={'!w-[450px]'}
            classNameContent={'!max-h-fit'}
            show={show}
            onHide={onHideForm}
            title={`${!dataAwardCategory?.id ? 'Create' : 'Update'} Category Voting`}
            isLoading={isLoading}
            isDisabled={isDisabled}
            onSubmit={onSubmit}
        >
            <div className={'flex flex-col space-y-6 px-8 py-2 mb-2'}>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Nama Kategori</div>
                    <Input
                        className={'flex-1'}
                        name={'name'}
                        placeholder={'Masukkan nama kategori'}
                        value={dataAwardCategory?.name}
                        onChange={onChangeForm}
                    />
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Tipe</div>
                    <Select
                        name={'type'}
                        className={'flex-1'}
                        optionsClassName={'max-h-40'}
                        placeholder={`Pilih tipe`}
                        options={options}
                        value={dataAwardCategory?.type}
                        onChange={onChangeForm}
                    />
                </div>
            </div>
        </ModalForm>
    )
}
